import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Container as oContainer } from 'screens/components/AutosList/components/FilterTags/styles';

export const Container = styled(oContainer)`
  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.Transparent};
    position: relative;
    top: auto;
  }
  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    max-width: 966px;
    margin: 8px auto;
  }
`;
